import { useNavigate, useParams } from 'react-router-dom';

import { UploadContentLayout } from '@/layout';
import { TextSection } from '@/pages/Event/Text';

export const UploadContentText = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  return (
    <UploadContentLayout goBack={() => navigate(`/events/${eventId}/upload-content/requests`)}>
      <TextSection isUploaderPage />
    </UploadContentLayout>
  );
};
